import styled from "styled-components";

export const CardWrapper = styled.div`
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  position: relative;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: start;
  }
  .truncate-text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .card-header .title {
    color: #343c6a;
    font-size: 20px;
    font-weight: 700;
    line-height: 24.2px;
    padding-top: 15px;
  }
  & .header {
    font-weight: 500;
    font-size: 15px;
    color: #343c6a;
  }

  & .three-dots {
    cursor: pointer;
    font-size: 20px;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: end;
  }
  .foterNum {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .nafar {
    color: #343c6a;
    font-family: Inter;
    font-size: 16px;
    font-weight: 500;
    padding-top: 60px;
    line-height: 16px;
  }
  .num {
    color: #8490a5;
    font-size: 40px;
    font-weight: 500;
    line-height: 40px;
    padding-top: 40px;
    margin: 0px;
  }
  .date {
    color: rgba(132, 144, 165, 1);
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    display: flex;
    gap: 10px;
    align-items: center;
    padding-bottom: 5px;
  }
`;
export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 43px;
  z-index: 1;
  height: ${({ rezume }) => rezume || "50px"};
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8490a5;
  font-size: 12px;
  .editicon {
    color: #8490a5;
  }
  :hover {
    color: #6610f2;
    .editicon {
      color: #6610f2;
    }
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  color: #8490a5;
  gap: 6px;
  .delicon {
    color: #8490a5;
  }
  :hover {
    color: red;
    .delicon {
      color: red;
    }
  }
`;
export const Eye = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8490a5;
  font-size: 12px;
  .editicon {
    color: #8490a5;
  }
  :hover {
    color: #6610f2;
    .editicon {
      color: #6610f2;
    }
  }
`;
